export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-8 md:p-12">
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50 mb-3">51黑料 APP</h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
                随时随地吃瓜爆料！下载51黑料APP，第一时间接收今日黑料推送，不再错过任何精彩大瓜。支持iOS和Android双平台，安装即可开启吃瓜模式。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
                <button className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-bold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  iOS 下载
                </button>
                <button className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-700 text-background-50 font-bold text-sm hover:bg-primary-800 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  Android 下载
                </button>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-primary-400/30 flex items-center justify-center border-2 border-primary-300/50">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-3 rounded-2xl bg-background-50 flex items-center justify-center">
                  <span className="font-heading text-xl font-black text-primary-500">51</span>
                </div>
                <span className="text-sm font-bold text-background-50">黑料吃瓜</span>
                <p className="text-xs text-primary-200 mt-1">v2.6.0</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}